module.exports = __webpack_public_path__ + "298943b8306b6a14ce6c31bb5f374266.jpg";